import { Link } from '@inertiajs/react'
import PublicLayout from '../layouts/PublicLayout'
import Monogram from '../components/Monogram'
import usePoll from '../hooks/usePoll'

const MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' }
const STAGE_SHORT = {
  final: 'Final',
  third_place: '3º/4º',
  fifth_place: '5º/6º',
  seventh_place: '7º/8º',
  ninth_place: '9º/10º',
}

// "Final · 1–1 (5–4 g.p.)" from the team's perspective.
function deciderLabel(d) {
  const pens = d.teamPens != null ? ` (${d.teamPens}–${d.oppPens} g.p.)` : ''
  return `${STAGE_SHORT[d.stage]} · ${d.teamScore}–${d.oppScore}${pens}`
}

export default function FinalStandings({ currentEdition, editions, rows = [] }) {
  usePoll(15000)
  const slug = currentEdition.slug

  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="classificacao-final">
      <div className="sechead">
        <h3>Classificação Final</h3>
        <div className="rule"></div>
        <span className="note">{currentEdition.name}</span>
      </div>

      <div className="tbl fs-tbl">
        <div className="gh">
          <b>1º – 10º</b>
          <em>atualiza com as eliminatórias</em>
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th className="l">Equipa</th>
              <th className="l">Decidido em</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.position} className={r.position === 1 && r.team ? 'q' : ''}>
                <td className="pos">
                  <span className="n">{r.position}º</span>
                  {MEDALS[r.position] && <span className="medal">{MEDALS[r.position]}</span>}
                </td>
                <td className="team">
                  {r.team ? (
                    <div className="row">
                      <Monogram team={r.team} />
                      <b>{r.team.name}</b>
                    </div>
                  ) : (
                    <span className="tbd">A definir</span>
                  )}
                </td>
                <td className="decider">
                  {r.decider && (
                    <Link href={`/${slug}/jogo/${r.decider.gameNumber}`}>
                      {deciderLabel(r.decider)}
                    </Link>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PublicLayout>
  )
}
